window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.footer = window.locales.am.footer || {};window.locales.am.footer.footer = window.locales.am.footer.footer || {};window.locales.am.footer.footer = {...window.locales.am.footer.footer, ...{
    "homepage": "መነሻ ገጽ",
    "available_app_store": "በ App Store ይገኛል",
    "available_google_play": "በ Google Play ይገኛል",
    "copyright": "© Quantic Holdings, Inc. ሁሉም መብቶች የተጠበቁ ናቸው።",
    "privacy_policy": "የግላዊነት ፖሊሲ",
    "terms_and_conditions": "ውሎች እና ሁኔታዎች",
    "cookies": "ኩኪዎች"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.footer = window.locales.ar.footer || {};window.locales.ar.footer.footer = window.locales.ar.footer.footer || {};window.locales.ar.footer.footer = {...window.locales.ar.footer.footer, ...{
    "homepage": "الصفحة الرئيسية",
    "available_app_store": "متاح على App Store",
    "available_google_play": "متاح على Google Play",
    "copyright": "© Quantic Holdings, Inc. جميع الحقوق محفوظة.",
    "privacy_policy": "سياسة الخصوصية",
    "terms_and_conditions": "الشروط والأحكام",
    "cookies": "بسكويت"
}
};window.locales.en = window.locales.en || {};window.locales.en.footer = window.locales.en.footer || {};window.locales.en.footer.footer = window.locales.en.footer.footer || {};window.locales.en.footer.footer = {...window.locales.en.footer.footer, ...{
    "homepage": "Homepage",
    "available_app_store": "Available App Store",
    "available_google_play": "Available Google Play",
    "copyright": "© Quantic Holdings, Inc. All rights reserved.",
    "privacy_policy": "Privacy Policy",
    "terms_and_conditions": "Terms and Conditions",
    "cookies": "Cookies"
}
};window.locales.es = window.locales.es || {};window.locales.es.footer = window.locales.es.footer || {};window.locales.es.footer.footer = window.locales.es.footer.footer || {};window.locales.es.footer.footer = {...window.locales.es.footer.footer, ...{
    "homepage": "Página principal",
    "available_app_store": "Disponible en App Store",
    "available_google_play": "Disponible en Google Play",
    "copyright": "© Quantic Holdings, Inc. Todos los derechos reservados.",
    "privacy_policy": "Política de privacidad",
    "terms_and_conditions": "Términos y condiciones",
    "cookies": "Cookies"
}
};window.locales.it = window.locales.it || {};window.locales.it.footer = window.locales.it.footer || {};window.locales.it.footer.footer = window.locales.it.footer.footer || {};window.locales.it.footer.footer = {...window.locales.it.footer.footer, ...{
    "homepage": "Homepage",
    "available_app_store": "Disponibile App Store",
    "available_google_play": "Disponibile Google Play",
    "copyright": "© Quantic Holdings, Inc. Tutti i diritti riservati.",
    "privacy_policy": "Informativa sulla Privacy",
    "terms_and_conditions": "Termini e Condizioni",
    "cookies": "Cookies"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.footer = window.locales.zh.footer || {};window.locales.zh.footer.footer = window.locales.zh.footer.footer || {};window.locales.zh.footer.footer = {...window.locales.zh.footer.footer, ...{
    "homepage": "主页",
    "available_app_store": "可用应用商店",
    "available_google_play": "可用应用商店",
    "copyright": "© Quantic Holdings, Inc。保留所有权利。",
    "privacy_policy": "隐私政策",
    "terms_and_conditions": "条款和条件",
    "cookies": "缓存文件"
}
};